import React from "react";
import HighlightText from "./HighlightText";
import partner from "../data/partner.json";
import Slider from "react-slick";

const Partners = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    autoplay: true,
    slidesToShow: 6,
    slidesToScroll: 1,
    autoplaySpeed: 700,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          initialSlide: 1,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
    ],
  };

  return (
    <div className="!pt-[30px] !pb-[30px] md:!pt-[50px] md:!pb-[40px]">
      <div className="flex flex-col w-11/12 mx-auto">
        <h3 className="text-richblack-800 text-2xl md:text-4xl font-bold">
          More than <HighlightText text={"100+"} fontSize={"4xl"} /> companies
          are hiring our graduates through our Campus Placement Programmes!
        </h3>
      </div>
      <div className="!pt-[20px] md:!pt-[30px]">
        <Slider {...settings}>
          {partner.map((item) => (
            <div
              key={item.id}
              className="flex justify-center items-center px-4"
            >
              <img
                src={`/images/logo/${item.logo}`}
                alt={item.logo}
                className="h-16 w-auto object-contain"
              />
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default Partners;

// import { Swiper, SwiperSlide } from "swiper/react";
// import { Autoplay, Navigation } from "swiper/modules";
// import "swiper/css";
// import "swiper/css/navigation";
// import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

// function LogoSlider({ autoplay = true, navigation = false }) {

//   const logos = [
//     "/images/logo/accolite.png",
//     "/images/logo/amazon.png",
//     "/images/logo/brillio.png",
//     "/images/logo/cisco.png",
//     "/images/logo/cognization.png",
//     "/images/logo/Diamond-engineering.png",
//     "/images/logo/eurofins.png",
//     "/images/logo/foodhub.png",
//     "/images/logo/global-analytics.png",
//     "/images/logo/goldman.png",
//     "/images/logo/hcl.png",
//     "/images/logo/hexaware.png",
//     "/images/logo/infosys.png",
//     "/images/logo/intellect.png",
//     "/images/logo/JTG.png",
//     "/images/logo/L&T.png",
//     "/images/logo/latentview.png",
//     "/images/logo/lucid.png",
//     "/images/logo/mastech.png",
//     "/images/logo/mcdermott.png",
//     "/images/logo/mindtree.png",
//     "/images/logo/Morgan.png",
//     "/images/logo/mr-cooper.png",
//     "/images/logo/multicoreware.png",
//     "/images/logo/Net-Objex.png",
//     "/images/logo/OEC.png",
//     "/images/logo/presidio.png",
//     "/images/logo/Prodapt.png",
//     "/images/logo/Renault.png",
//     "/images/logo/SEG-International.png",
//     "/images/logo/Soliton.png",
//     "/images/logo/TCS.png",
//     "/images/logo/tech-mahindra.png",
//     "/images/logo/temenos.png",
//     "/images/logo/thoughworks.png",
//     "/images/logo/tiger.png",
//     "/images/logo/uniq.png",
//     "/images/logo/verizon.png",
//     "/images/logo/Zilker.png",
//     "/images/logo/zoho.png",
//   ];

//   return (
//     <div className="py-5 bg-white overflow-visible relative">
//       {navigation && (
//         <>
//           <button className="logo-prev absolute left-0 md:left-[-20px] top-1/2 transform -translate-y-1/2 z-10 bg-white shadow-md p-2 rounded-full">
//             <FaChevronLeft className="text-gray-600" />
//           </button>
//           <button className="logo-next absolute right-2 top-1/2 transform -translate-y-1/2 z-10 bg-white shadow-md p-2 rounded-full">
//             <FaChevronRight className="text-gray-600" />
//           </button>
//         </>
//       )}

//       <Swiper
//         slidesPerView={5}
//         spaceBetween={30}
//         loop={true}
//         slidesPerGroup={1}
//         speed={600}
//         autoplay={autoplay ? { delay: 0, disableOnInteraction: false } : false}
//         navigation={navigation ? { nextEl: ".logo-next", prevEl: ".logo-prev" } : false}
//         breakpoints={{
//           320: { slidesPerView: 2, spaceBetween: 20 },
//           500: { slidesPerView: 3, spaceBetween: 20 },
//           768: { slidesPerView: 4, spaceBetween: 25 },
//           1024: { slidesPerView: 7, spaceBetween: 30 },
//         }}
//         modules={[Autoplay, Navigation]}
//         className="flex items-center"
//       >
//         {logos.map((logo, index) => (
//           <SwiperSlide key={index} className="w-auto">
//             <img src={logo} alt={`Brand ${index + 1}`} className="w-40 object-contain h-16" />
//           </SwiperSlide>
//         ))}
//       </Swiper>
//     </div>
//   );
// }

// export default LogoSlider;
